import { NextResponse } from 'next/server'

export const middleware = (request) => {
    const path = request.nextUrl.pathname
    const queryParams = request.nextUrl.searchParams
    const emailQuery = queryParams.get('email')
    const authPages = [
        '/signin/',
        '/signup/',
        '/forgot-password/',
        '/reset-password/',
        '/otp-verification/',
        '/',
        '/about-us/',
        '/contact-us/',
        '/events/',
        '/payment/'
    ]
    const userAuthPages = ['/my-account/', '/edit-profile/']
    const isUserAuth = userAuthPages.includes(path)
    const isAuthRoute = authPages.includes(path)
    const NotDirectAccessRoute = ['/reset-password/', '/otp-verification/']
    const isNotDirectAccessRoute = NotDirectAccessRoute.includes(path)
    const tokenValue = request.cookies.get('authTokenNamascapeWeb')?.value || ''
    const userType = request.cookies.get(`userTypeNamascape`)?.value || ''
    const currentPage = request.cookies.get(`currentPage`)?.value || '/'
    if ((isAuthRoute || isUserAuth) && tokenValue && userType === '1') {
        return NextResponse.redirect(new URL('/dashboard/', request.url))
    }
    if (isNotDirectAccessRoute && !tokenValue && !emailQuery) {
        return NextResponse.redirect(new URL('/signin/', request.url))
    }

    if (!isAuthRoute && !tokenValue) {
        return NextResponse.redirect(new URL('/signin/', request.url))
    }
    if (tokenValue && userType === '2') {
        const nonAuthRoutes = [
            '/dashboard/',
            '/event-management/',
            '/event-booking/',
            '/signin/',
            '/signup/',
            '/otp-verification/',
            '/reset-password/',
            '/forgot-password/',
            '/myaccount/',
        ]
        const isNonAuthRoute = nonAuthRoutes.includes(path)
        if (isNonAuthRoute) {
            return NextResponse.redirect(new URL(currentPage, request.url))
        }
    }
    const url = request.nextUrl.clone();
    if (url.pathname === '/') {
        url.pathname = '/sponsored/';
        return NextResponse.rewrite(url);
    }
}
export const config = {
    matcher: [
        '/signin/',
        '/signup/',
        '/forgot-password/',
        '/reset-password/',
        '/otp-verification/',
        '/',
        '/dashboard/',
        '/about-us/',
        '/contact-us/',
        '/events/',
        '/event-management/',
        '/organizer-profile/',
        '/event-booking/',
        '/myaccount/',
        '/myaccount/change-password/',
        '/credit-card/',
        '/twint/',
        '/myaccount/personal-details/',
        '/myaccount/bank-details/',
        '/my-account/',
        '/edit-profile/',
        '/change-password/',
        '/change-language/',
        '/create-event/',
        '/create-event/:path*/',
        '/payment/',
        "/termsandconditions/",
        '/e-ticket/',
        '/terms-of-service/',
        '/privacy-policy-tab/',
        '/event-booking/:path*/',
        '/payment/:path*/',
        '/status/',
        "/event-attendees/:path*/",
        "/karma-points-history/",
    ]
}
